import * as React from "react";
import { Link } from "react-router-dom";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IUserSession from "../../types/IUserSession";

import NavDropdown from "./NavDropdown";

interface INavCustomerProps extends ITranslationProps {
    userSession: IUserSession | null;
}

interface INavCustomerState {
    isOpen: boolean;
    collapsed: boolean;
}

class NavCustomer extends React.Component<INavCustomerProps, INavCustomerState> {

    constructor(props: INavCustomerProps) {
        super(props);

        this.state = { 
            isOpen: false,
            collapsed: true
        };

        this.menuToggled = this.menuToggled.bind(this);
        this.toggleNavbar = this.toggleNavbar.bind(this);
    }

    public render() {
        if (this.props.userSession && this.props.userSession.clientHeaders && this.props.userSession.clientHeaders.length > 1) {
            const collapsed = this.state.collapsed;
            const navbarCollapseClass = collapsed ? "collapse navbar-collapse" : "collapse navbar-collapse show";
            const collapseButtonClass = collapsed ? "navbar-toggler navbar-toggler-right collapsed" : "navbar-toggler navbar-toggler-right";

            const customerMenus = this.props.userSession.clientHeaders.map((clientHeader, index) => {
                if (index === 0) {
                    // current customer user is already logged into
                    return <div key={index}><div className="dropdown-item">{clientHeader.name}</div><div className="dropdown-divider" /></div>;
                } else {
                    return <Link key={index} to={`/changeCustomer/${clientHeader.id}`} className="dropdown-item">{clientHeader.name}</Link>
                }
            });

            return (
                <div>
                    <nav className="navbar navbar-expand-md navbar-dark bg-dark">
                        <Link to="" className="navbar-brand" />
                        <button 
                            onClick={this.toggleNavbar}
                            className={collapseButtonClass} 
                            type="button" 
                            data-toggle="collapse"
                            data-target="#navbarCustomerCollapse" 
                            aria-controls="navbarCustomerCollapse"
                            aria-expanded="false" 
                            aria-label="Toggle navigation">
                            {this.props.userSession.clientHeaders[0].name}
                        </button>
                        <div className={navbarCollapseClass} id="navbarCustomerCollapse">
                            <ul className="navbar-nav mr-auto" />
                            <div className="navbar-nav">
                                <NavDropdown name={this.props.userSession.clientHeaders[0].name} id={99999} isOpen={this.state.isOpen} toggleMenu={this.menuToggled}>
                                    {customerMenus}
                                </NavDropdown>
                            </div>
                        </div>
                    </nav>
                </div>
            );
        } else {
            return <div />;
        }
    }

    private menuToggled(id: number, visible: boolean) {
        this.setState({ isOpen: visible });
    }

    private toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }
}

export default translateComponent(NavCustomer);



// WEBPACK FOOTER //
// ./src/components/Nav/NavCustomer.tsx